module.exports = __webpack_public_path__ + "static/Ethermon-2ed801e9b3708f7dc54f29f94972ce94.png";